if (document.querySelector('#success-apply') || document.querySelector('#success-register')) {
    var formSubmitted = "";
    function updateVisibility(el) {
        document.getElementById(el).classList.add('visible');
        document.getElementById(el).setAttribute("aria-hidden", "false");
    }

    // we display a few items for status, so we'll add those in an additional func
    function displayApplyContent() {
        updateVisibility('success-apply');
        updateVisibility('success-status');
    }

    // Run script once page has loaded
    document.addEventListener("DOMContentLoaded", function() {
        var isApplyFlag = localStorage.getItem('is-application');
        if (isApplyFlag == null) {
            formSubmitted = "Apply at Chisholm";
            displayApplyContent();
        } else {
            if (isApplyFlag == 'true') {
                formSubmitted = "Apply at Chisholm";
                displayApplyContent(); 
            } else {
                formSubmitted = "Register Your Interest";
                updateVisibility('success-register');
            }
        }
    });
}